var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"home"},[_c('section',{staticClass:"main product__management",staticStyle:{"display":"block"}},[_c('p',{staticStyle:{"font-size":"32px","font-weight":"bold","border-bottom":"1px solid lightgray"}},[_vm._v(" "+_vm._s(_vm.$t("FilialeOverview"))+" ")]),_c('FilialeOverview')],1)])
}
var staticRenderFns = []

export { render, staticRenderFns }